module.exports = __webpack_public_path__ + "img/xt11@2x.5f63c6bf.png";